import React, { useState } from "react";
import { Avatar, Dropdown, MenuItem } from "@heathmont/moon-core-tw";
import { GenericLogOut } from "@heathmont/moon-icons";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { store } from "../../../store/store";
import {
  getBorderColor,
  getTextColor,
} from "../../../utils/Colors/colorSetting";
import { removeUser } from "../../../features/Auth Slice/authSlice";
import { capitalizeWords } from "../../../utils/capitalizeWords";
import { logout } from "../../../services/auth.service";
const ProfileButton = ({ value, role, imageUrl, roles }: any) => {
  const [option, setOption] = useState({ name: value });
  const borderColor = getBorderColor(role);
  const textColor = getTextColor(role);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const logOut = () => {
    logout();
  };
  return (
    <>
      <Dropdown value={option} onChange={setOption}>
        <Dropdown.Trigger
          className={`flex items-center font-normal  w-auto bg-primarydark text-white
                         py-1 px-1.5 rounded-xl cursor-pointer`}
        >
          <img className="me-1.5" src={imageUrl} alt="img" />
          {capitalizeWords(value)}
        </Dropdown.Trigger>

        <Dropdown.Options className="min-w-[200px] max-w-[200px]">
          <div className="text-center p-3">
            <Avatar
              className={`rounded-full border-2 inline-block imgAvatarRounded mb-1 ${borderColor}`}
              imageUrl={imageUrl}
              size="xl"
            />
            <h3 className="text-moon-14 capitalize">{value}</h3>
            <p className={`text-moon-12 inline-block px-2 leading-none py-1 capitalize rounded-sm ${textColor}`}>{role}</p>
          </div>
          <hr className="my-1" />
          <Dropdown.Option>
            <div>
              <MenuItem
                className="font-normal text-gray-400 text-moon-12"
                onClick={() => {
                  navigate("/profile");
                }}
              >
                Profile
              </MenuItem>
              {/* <MenuItem className="font-normal text-gray-400 text-moon-12">
                Preferences
              </MenuItem> */}
              <hr className="my-1" />
              <MenuItem
                className="font-normal text-moon-12 justify-start"
                onClick={logOut}
              >
                <GenericLogOut /> {""} Log out
              </MenuItem>
            </div>
          </Dropdown.Option>
        </Dropdown.Options>
      </Dropdown>
    </>
  );
};

export default ProfileButton;
